import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AbstractAsset} from '../../../../../class/abstract-asset';
import {AssetResource} from '../../../../../class/lifeproject/asset-resource';

@Component({
  selector: 'app-asset-editor',
  templateUrl: './asset-editor.component.html',
  styleUrls: ['./asset-editor.component.css']
})
export class AssetEditorComponent implements OnInit {

  @Input()
  asset: AbstractAsset;

  selectedValue: number;

  @Output()
  value = new EventEmitter<AssetResource>();

  constructor() {
  }

  ngOnInit() {
    if (!this.asset.usedValue) {
      this.asset.usedValue = 0;
    }
  }

  confirmValue() {
    this.asset.usedValue += this.selectedValue;
    const res = new AssetResource();
    res.asset = this.asset;
    res.selectedValue = this.selectedValue;
    this.value.emit(res);
  }
}
